// extracted by mini-css-extract-plugin
export default {"container":"Presentacion_container__Pjp5o","title":"Presentacion_title__pvtdz","text":"Presentacion_text__bXJCu"};